<div class="card h-full flex flex-column">
  <app-header
    [titulo]="'Fluxo do Processo: ' + (processo?.nome || '')"
    descricao="Organize a ordem de execução e configure cada recurso.">
  </app-header>

  <p-toolbar styleClass="mb-4">
    <ng-template pTemplate="left">
      <p-button label="Voltar" icon="pi pi-arrow-left" severity="secondary" (onClick)="voltar()" styleClass="mr-2"></p-button>
      <p-button label="Executar" icon="pi pi-play" severity="success" (onClick)="executarProcesso()"></p-button>
    </ng-template>
  </p-toolbar>

  <div class="grid flex-grow-1" style="min-height: 600px;">
    <!-- Lista de Recursos (Esquerda) -->
    <div class="col-12 md:col-4 lg:col-3 h-full">
      <div class="surface-card shadow-2 border-round h-full flex flex-column">
        <div class="p-3 border-bottom-1 surface-border flex justify-content-between align-items-center bg-gray-50 border-round-top">
          <span class="font-bold text-900">Recursos</span>
          <p-menu #menuAdd [model]="tiposRecursoOptions" [popup]="true"></p-menu>
          <p-button icon="pi pi-plus" label="Adicionar" styleClass="p-button-sm" (onClick)="menuAdd.toggle($event)"></p-button>
        </div>
        
        <div class="flex-grow-1 overflow-auto p-2">
            <p-orderList [value]="recursos" [listStyle]="{'height':'auto', 'max-height':'100%'}" 
                [dragdrop]="true" (onReorder)="onReorder($event)" styleClass="w-full">
                <ng-template pTemplate="item" let-recurso>
                    <div class="flex align-items-center p-2 w-full cursor-pointer hover:surface-hover border-round transition-colors transition-duration-150"
                        [class.surface-highlight]="recurso.id === recursoSelecionado?.id"
                        (click)="selecionarRecurso(recurso)">
                        
                        <div class="flex align-items-center justify-content-center border-circle mr-3" 
                             style="width: 32px; height: 32px;"
                             [class.bg-blue-100]="recurso.tipoRecurso === 'IMPORTACAO'"
                             [class.bg-orange-100]="recurso.tipoRecurso === 'PROCESSAMENTO'"
                             [class.bg-teal-100]="recurso.tipoRecurso === 'VISUALIZACAO'"
                             [class.bg-purple-100]="recurso.tipoRecurso === 'EXPORTACAO'"
                             [class.bg-pink-100]="recurso.tipoRecurso === 'PUBLICACAO'">
                             <i [class]="getIconeRecurso(recurso.tipoRecurso)" class="text-xl text-600"></i>
                        </div>
                        
                        <div class="flex-grow-1">
                            <span class="font-bold block text-900">{{ recurso.nome }}</span>
                            <span class="text-sm text-500">{{ recurso.tipoRecurso }}</span>
                        </div>
                        
                        <div class="flex align-items-center">
                            <i class="pi pi-bars text-400 mr-2 handle-drag"></i>
                            <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-text p-button-danger p-button-sm" 
                                (onClick)="$event.stopPropagation(); excluirRecurso(recurso)"></p-button>
                        </div>
                    </div>
                </ng-template>
            </p-orderList>
            
            <div *ngIf="recursos.length === 0 && !loading" class="text-center p-4 text-500">
                <i class="pi pi-info-circle mb-2"></i>
                <p>Nenhum recurso adicionado.</p>
            </div>
        </div>
      </div>
    </div>

    <!-- Painel de Configuração (Direita) -->
    <div class="col-12 md:col-8 lg:col-9 h-full">
      <div class="surface-card shadow-2 border-round h-full p-4 overflow-auto" *ngIf="recursoSelecionado; else emptyState">
        <!-- Header do Painel -->
        <div class="flex justify-content-between align-items-center border-bottom-1 surface-border pb-3 mb-4">
            <div>
                <h2 class="m-0 text-900" *ngIf="!isNew">Editando: {{ recursoSelecionado.nome }}</h2>
                <h2 class="m-0 text-900" *ngIf="isNew">Novo Recurso: {{ recursoSelecionado.tipoRecurso | titlecase }}</h2>
                <div class="flex align-items-center gap-2 mt-2">
                    <p-tag [value]="recursoSelecionado.tipoRecurso"></p-tag>
                    <span class="text-500">Ordem: {{ recursoSelecionado.ordemExecucao }}</span>
                </div>
            </div>
            <div class="flex gap-2">
                <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-text" (onClick)="cancelarEdicao()" *ngIf="isNew"></p-button>
                <p-button label="Salvar Alterações" icon="pi pi-save" (onClick)="salvarRecurso()" [loading]="loadingDetalhes"></p-button>
            </div>
        </div>

        <div *ngIf="loadingDetalhes" class="flex justify-content-center p-5">
            <p-progressSpinner></p-progressSpinner>
        </div>

        <div *ngIf="!loadingDetalhes" class="formgrid grid">
            <!-- Dados Gerais do Recurso -->
            <div class="field col-12 md:col-6">
                <label for="nome" class="font-bold">Nome do Recurso</label>
                <input pInputText id="nome" [(ngModel)]="recursoSelecionado.nome" class="w-full" />
            </div>
            <div class="field col-12 md:col-6">
                <label for="descricao" class="font-bold">Descrição</label>
                <textarea pInputTextarea id="descricao" [(ngModel)]="recursoSelecionado.descricao" rows="1" class="w-full"></textarea>
            </div>

            <p-divider styleClass="col-12"></p-divider>

            <!-- Configuração Específica: Importação/Exportação (Comandos) -->
            <div *ngIf="comandoDetalhe" class="col-12">
                <h3 class="text-900 mb-3">Configuração do Comando</h3>
                <div class="grid">
                    <div class="field col-12 md:col-6">
                        <label for="cmdNome" class="font-bold">Nome do Comando</label>
                        <input pInputText id="cmdNome" [(ngModel)]="comandoDetalhe.nome" class="w-full" />
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="cmdTipo" class="font-bold">Tipo de Comando</label>
                        <p-dropdown id="cmdTipo" [options]="opcoesTipoComando" [(ngModel)]="comandoDetalhe.tipo" styleClass="w-full"></p-dropdown>
                    </div>
                    
                    <div class="field col-12 md:col-6">
                        <label for="conexao" class="font-bold">Conexão</label>
                        <p-dropdown id="conexao" [options]="todasConexoes" [(ngModel)]="comandoDetalhe.conexaoId" 
                            optionLabel="nome" optionValue="id" placeholder="Selecione a conexão" 
                            styleClass="w-full" [filter]="true" (onChange)="onConexaoChange($event.value)"></p-dropdown>
                    </div>

                    <div class="field col-12 md:col-6" *ngIf="comandoDetalhe.tipo === 'API_ENDPOINT'">
                         <label for="endpoint" class="font-bold">Endpoint</label>
                         <p-dropdown id="endpoint" [options]="todosEndpoints" [(ngModel)]="comandoDetalhe.endpointId" 
                            optionLabel="nome" optionValue="id" placeholder="Selecione o endpoint" 
                            styleClass="w-full" [filter]="true"></p-dropdown>
                    </div>

                    <div class="field col-12" *ngIf="recursoSelecionado.tipoRecurso === 'IMPORTACAO'">
                        <label for="camposChave" class="font-bold">Campos Chave (Diferencial)</label>
                        <p-chips id="camposChave" [(ngModel)]="comandoDetalhe.camposChave" styleClass="w-full" placeholder="Ex: ID_BOMBA, CD_EMPRESA"></p-chips>
                        <small class="text-500">Usado para identificar registros únicos e evitar duplicidades.</small>
                    </div>

                    <div class="field col-12" *ngIf="comandoDetalhe.tipo === 'DATABASE_SQL'">
                        <label for="script" class="font-bold">SQL / Query</label>
                        <textarea pInputTextarea id="script" [(ngModel)]="comandoDetalhe.comando" rows="10" class="w-full font-mono" placeholder="SELECT * FROM ..."></textarea>
                    </div>
                </div>
            </div>

            <!-- Configuração Específica: Processamento/Visualização (Mapeamentos) -->
            <div *ngIf="mapeamentoDetalhe" class="col-12">
                <h3 class="text-900 mb-3">Configuração de Mapeamento</h3>
                <div class="field">
                    <label for="mapNome" class="font-bold">Nome do Mapeamento</label>
                    <input pInputText id="mapNome" [(ngModel)]="mapeamentoDetalhe.nome" class="w-full mb-3" />
                </div>
                
                <app-editor-mapeamento 
                    [mapeamentos]="mapeamentoDetalhe.mapeamentos" 
                    (mapeamentosAlterados)="mapeamentoDetalhe.mapeamentos = $event">
                </app-editor-mapeamento>
            </div>

             <!-- Configuração Específica: Publicação -->
             <div *ngIf="publicacaoConfig" class="col-12">
                <h3 class="text-900 mb-3">{{ recursoSelecionado.tipoRecurso === 'VISUALIZACAO' ? 'Configuração de Visualização' : 'Configuração de Publicação' }}</h3>
                <div class="grid">
                    <div class="field col-12 md:col-6">
                        <label for="pubNome" class="font-bold">Nome da Configuração</label>
                        <input pInputText id="pubNome" [(ngModel)]="publicacaoConfig.nome" class="w-full" />
                    </div>
                    
                    <ng-container *ngIf="recursoSelecionado.tipoRecurso !== 'VISUALIZACAO'">
                        <div class="field col-12 md:col-6">
                            <label for="pubCodigo" class="font-bold">Código (Slug URL)</label>
                            <input pInputText id="pubCodigo" [(ngModel)]="recursoSelecionado.codigo" class="w-full" placeholder="ex: api-v1-vendas" />
                        </div>
                        <div class="field col-12 md:col-4">
                            <label for="pubDirecao" class="font-bold">Direção</label>
                            <p-dropdown id="pubDirecao" [options]="opcoesDirecao" [(ngModel)]="publicacaoConfig.direcao" styleClass="w-full"></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label for="pubFormato" class="font-bold">Formato Resposta</label>
                            <p-dropdown id="pubFormato" [options]="opcoesFormatoResposta" [(ngModel)]="publicacaoConfig.formatoResposta" styleClass="w-full"></p-dropdown>
                        </div>
                    </ng-container>

                    <div class="field col-12 md:col-4 flex align-items-end pb-3">
                        <div class="flex align-items-center gap-2">
                            <p-checkbox [(ngModel)]="publicacaoConfig.ativo" [binary]="true" inputId="pubAtivo"></p-checkbox>
                            <label for="pubAtivo" class="font-bold">Configuração Ativa</label>
                        </div>
                    </div>

                    <!-- SEÇÃO OUTBOUND -->
                    <div class="col-12" *ngIf="publicacaoConfig.direcao === 'OUTBOUND' || publicacaoConfig.direcao === 'BIDIRECIONAL'">
                        <p-divider align="left">
                            <div class="inline-flex align-items-center">
                                <i class="pi pi-sign-out mr-2"></i>
                                <b>Configurações de Saída (OUTBOUND)</b>
                            </div>
                        </p-divider>
                        <div class="grid">
                            <div class="field col-12 md:col-6" *ngIf="recursoSelecionado.tipoRecurso !== 'VISUALIZACAO'">
                                <label for="pubFonte" class="font-bold">Fonte de Dados</label>
                                <p-dropdown id="pubFonte" [options]="opcoesFonteDados" [(ngModel)]="publicacaoConfig.fonteDados" styleClass="w-full"></p-dropdown>
                            </div>
                            <div class="field col-12 md:col-6">
                                <label for="ordenacao" class="font-bold">Ordenação Padrão</label>
                                <input pInputText id="ordenacao" [(ngModel)]="publicacaoConfig.ordenacaoPadrao" class="w-full" placeholder="ex: criadoEm desc" />
                            </div>
                            <div class="field col-12">
                                <label for="camposRetorno" class="font-bold">Campos de Retorno (JSON)</label>
                                <p-chips id="camposRetorno" [(ngModel)]="publicacaoConfig.camposRetorno" styleClass="w-full" placeholder="Digite o nome do campo e pressione Enter"></p-chips>
                            </div>
                            <div class="field col-12">
                                <label for="camposFiltro" class="font-bold">Campos Permitidos para Filtro</label>
                                <p-chips id="camposFiltro" [(ngModel)]="publicacaoConfig.camposFiltro" styleClass="w-full" placeholder="Digite o campo e pressione Enter"></p-chips>
                            </div>
                            <div class="field col-12 md:col-4 flex align-items-center pt-4">
                                <p-checkbox [(ngModel)]="publicacaoConfig.suportaPaginacao" [binary]="true" inputId="paginacao"></p-checkbox>
                                <label for="paginacao" class="ml-2 font-bold">Suporta Paginação</label>
                            </div>
                            <div class="field col-12 md:col-4" *ngIf="publicacaoConfig.suportaPaginacao">
                                <label for="limite" class="font-bold">Limite Padrão</label>
                                <p-inputNumber id="limite" [(ngModel)]="publicacaoConfig.limitePadrao" styleClass="w-full"></p-inputNumber>
                            </div>
                            <div class="field col-12 md:col-4" *ngIf="publicacaoConfig.suportaPaginacao">
                                <label for="limiteMax" class="font-bold">Limite Máximo</label>
                                <p-inputNumber id="limiteMax" [(ngModel)]="publicacaoConfig.limiteMaximo" styleClass="w-full"></p-inputNumber>
                            </div>
                        </div>
                    </div>

                    <!-- SEÇÃO INBOUND -->
                    <div class="col-12" *ngIf="publicacaoConfig.direcao === 'INBOUND' || publicacaoConfig.direcao === 'BIDIRECIONAL'">
                        <p-divider align="left">
                            <div class="inline-flex align-items-center">
                                <i class="pi pi-sign-in mr-2"></i>
                                <b>Configurações de Entrada (INBOUND)</b>
                            </div>
                        </p-divider>
                        <div class="grid">
                            <div class="field col-12 md:col-4">
                                <label for="destinoDados" class="font-bold">Destino dos Dados</label>
                                <p-dropdown id="destinoDados" [options]="opcoesDestinoRecebimento" [(ngModel)]="publicacaoConfig.destinoDados" styleClass="w-full"></p-dropdown>
                            </div>
                            <div class="field col-12 md:col-4">
                                <label for="modoProc" class="font-bold">Modo Processamento</label>
                                <p-dropdown id="modoProc" [options]="opcoesModoProcessamento" [(ngModel)]="publicacaoConfig.modoProcessamento" styleClass="w-full"></p-dropdown>
                            </div>
                            <div class="field col-12 md:col-4 flex align-items-center pt-4 gap-4">
                                <div class="flex align-items-center">
                                    <p-checkbox [(ngModel)]="publicacaoConfig.validarSchema" [binary]="true" inputId="validarSchema"></p-checkbox>
                                    <label for="validarSchema" class="ml-2 font-bold">Validar Schema</label>
                                </div>
                                <div class="flex align-items-center">
                                    <p-checkbox [(ngModel)]="publicacaoConfig.permitirCamposExtras" [binary]="true" inputId="camposExtras"></p-checkbox>
                                    <label for="camposExtras" class="ml-2 font-bold">Campos Extras</label>
                                </div>
                            </div>
                            
                            <div class="field col-12 md:col-6" *ngIf="publicacaoConfig.destinoDados === 'BANCO_DADOS'">
                                <label for="comandoDest" class="font-bold">Comando de Destino</label>
                                <p-dropdown id="comandoDest" [options]="todosComandos" [(ngModel)]="publicacaoConfig.comandoDestinoId" 
                                    optionLabel="nome" optionValue="id" placeholder="Selecione um comando" styleClass="w-full" [filter]="true"></p-dropdown>
                            </div>
                            <div class="field col-12 md:col-6" *ngIf="publicacaoConfig.destinoDados === 'BANCO_DADOS' || publicacaoConfig.destinoDados === 'FILA_PROCESSAMENTO'">
                                <label for="mapReceb" class="font-bold">Mapeamento de Entrada</label>
                                <p-dropdown id="mapReceb" [options]="todosMapeamentos" [(ngModel)]="publicacaoConfig.mapeamentoRecebimentoId" 
                                    optionLabel="nome" optionValue="id" placeholder="Selecione um mapeamento" styleClass="w-full" [filter]="true"></p-dropdown>
                            </div>

                            <div class="field col-12">
                                <label for="camposObrigatorios" class="font-bold">Campos Obrigatórios</label>
                                <p-chips id="camposObrigatorios" [(ngModel)]="publicacaoConfig.camposObrigatorios" styleClass="w-full" placeholder="Digite os campos obrigatórios"></p-chips>
                            </div>

                            <div class="field col-12" *ngIf="publicacaoConfig.validarSchema">
                                <label for="schema" class="font-bold">JSON Schema de Entrada</label>
                                <textarea pInputTextarea id="schema" [(ngModel)]="publicacaoConfig.schemaEntrada" rows="5" class="w-full font-mono" placeholder='{ "type": "object", ... }'></textarea>
                            </div>
                        </div>
                    </div>
                </div>
             </div>
        </div>
      </div>

      <ng-template #emptyState>
        <div class="h-full flex flex-column align-items-center justify-content-center surface-card shadow-2 border-round text-center p-5">
            <img src="assets/layout/images/lxtech-logo.png" alt="Logo" class="mb-4 opacity-20" style="max-width: 150px; filter: grayscale(100%);">
            <h2 class="text-900 mb-2">Nenhum Recurso Selecionado</h2>
            <p class="text-600 max-w-30rem line-height-3">Selecione um recurso na lista à esquerda para editar suas configurações ou adicione um novo recurso ao fluxo.</p>
        </div>
      </ng-template>
    </div>
  </div>

  <p-confirmDialog></p-confirmDialog>
</div>
